import debounce from 'debounce';
import select from 'dom-select';

export const Marquee = (el) => {
  const ui = {
    el,
    body: select('body', document),
    main: select('.marquee__main', el),
    image: select('.marquee__img', el),
    wrapper: select('#js-main-wrap', el)
  };

  const threshold = 834;

  // Dynamically adjusts main wrapper height based on viewport width - on larger screens,
  // limits wrapper to half the marquee height; removes constraint on smaller screens.
  // Only the original layout's card overlaps the photo
  const resizeMainWrapper = () => {
    if (!ui.body || !ui.main || !ui.image || !ui.wrapper || !ui.el.classList.contains('marquee--original')) {
      return;
    }

    let bodySize = ui.body.getBoundingClientRect();
    let bodyWidth = bodySize.width;
    
    if (bodyWidth >= threshold) {
      let measurements = ui.main.getBoundingClientRect();
      let desiredHeight = measurements.height / 2;
      ui.wrapper.style.maxHeight = `${desiredHeight}px`;
    } else {
      ui.wrapper.removeAttribute('style');
    }
  };

  const debouncedResizeMainWrapper = debounce(() => {
      resizeMainWrapper();
    }, 50);

  const addEvents = () => {
    window.addEventListener('resize', () => {
      debouncedResizeMainWrapper();
    });
  }

  const init = () => {  
    // Only initialize if we have the minimum required elements
    if (!ui.main) {
      console.warn('Marquee: Required elements not found, skipping initialization');
      return;
    }

    addEvents();
    resizeMainWrapper();
  };

  init();
};

export default Marquee;
